<template>
  <div class="issue">
    <div class="title">
      <p>急需解决的问题</p>
      <div class="line"></div>
    </div>
    <div class="content">
      <div class="item-box">
        <div class="item">
          <div class="line"></div>
          <img src="../../static/images/product/issue_box.png" />
          <p>新老客户判定</p>
          <img class="icon" src="../../static/images/product/first.png" />
        </div>
        <p class="desc">
          无法获取真正的刚需客户，对客户无法进行判定，无法提供精准服务。
        </p>
      </div>

      <div class="item-box">
        <div class="item">
          <img src="../../static/images/product/issue_box.png" />
          <p>渠道截客</p>
          <img class="icon" src="../../static/images/product/two.png" />
        </div>
        <p class="desc">
          渠道商在案场周边或者案场内拦截自然到访客户，唆使利诱客户以渠道客户名义成交。
        </p>
      </div>
      <div class="item-box">
        <div class="item">
          <img src="../../static/images/product/issue_box.png" />
          <p>内单外飞</p>
          <img class="icon" src="../../static/images/product/three.png" />
        </div>
        <p class="desc">
          中介渠道串通开发商行销拓客团队，或利诱其他佣金较低渠道，将客户转至高佣金渠道成交。
        </p>
      </div>
      <div class="item-box">
        <div class="item">
          <img src="../../static/images/product/issue_box.png" />
          <p>联名购房判客不准</p>
          <img class="icon" src="../../static/images/product/four.png" />
        </div>
        <p class="desc">顾问重复接待联名客户,浪费接待时间。</p>
      </div>
      <div class="item-box">
        <div class="item">
          <img src="../../static/images/product/issue_box.png" />
          <p>置业顾问洗客</p>
          <img class="icon" src="../../static/images/product/five.png" />
        </div>
        <p class="desc">内外场顾问串通洗客,额外支付佣金。</p>
      </div>
      <div class="item-box">
        <div class="item">
          <img src="../../static/images/product/issue_box.png" />
          <p>客流分析</p>
          <img class="icon" src="../../static/images/product/six.png" />
        </div>
        <p class="desc">
          每日真实进店人数无法统计进店内客户性别、年龄分析，多次重复进店客户数据筛选。
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    mouseenter() {},
    mouseleave() {},
  },
};
</script>
<style lang="stylus" scoped>
.issue {
  width: 100%;
  height: 834px;
  background: #F9FBFF;
  padding-top: 109px;
  box-sizing: border-box;

  .title {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    text-align: center;

    p {
      font-size: 30px;
      font-weight: bold;
      color: #333333;
    }

    .line {
      width: 42px;
      height: 2px;
      background: #FFC000;
      border-radius: 1px;
      margin-top: 29px;
    }
  }

  .content {
    display: flex;
    justify-content: center;
    margin-top: 84px;

    .item-box {
      max-width: 210px;
      transition: all 0.4s;
      margin-right: 40px;
    }

    .item-box:hover {
      transform: translateY(-30px);
      border-top: 4px solid #FFC000;
      border-radius: 20px 20px 0 0;
    }

    .item-box:hover .item p {
      font-weight: bold;
    }

    .item {
      position: relative;
      margin-bottom: 22px;
       max-width: 210px;

      p {
        width:100%;
        text-align:center;
        position: absolute;
        top: 175px;
        left:0;
        font-size: 18px;
        font-weight: 500;
       
      }

      .icon {
        position: absolute;
        top: 54px;
        left: 79px;
      }
    }

    .desc {
      font-size: 14px;
      font-weight: 500;
      color: #666666;
      line-height: 30px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/ProductIssue.vue